/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Generate_PdfsInputs */

const en_orders_generate_pdfs = /** @type {(inputs: Orders_Generate_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate PDFs`)
};

const es_orders_generate_pdfs = /** @type {(inputs: Orders_Generate_PdfsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar PDFs`)
};

/**
* | output |
* | --- |
* | "Generate PDFs" |
*
* @param {Orders_Generate_PdfsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_generate_pdfs = /** @type {((inputs?: Orders_Generate_PdfsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Generate_PdfsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_generate_pdfs(inputs)
	return es_orders_generate_pdfs(inputs)
});